module.exports = __webpack_public_path__ + "img/xbc.384d9f1c.png";